import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { useLogin } from "../uicontext/store";
import { Dialog } from "framework/dialog/dialog";
import { DialogContent } from "framework/dialog/dialog";
import { DialogTitle } from "framework/dialog/dialog";
import { DialogClose } from "framework/dialog/dialog";
import { Button, ButtonCloseIcon, ButtonLoginIcon, ButtonLogoutIcon, Intent } from "framework/controls/button";
import { TextField } from "framework/controls/text_field";
import { useResponsivity } from "framework/responsivity/store";
import { useUIContext } from "common/uicontext/store";
import { cls_colorMagenta60, cls_gap_form } from "style/index.css";
import { PasswordField } from "framework/controls/password_field";
import { cls_button_width, cls_gap_box_0, cls_gap_box_1, cls_input_box } from "./login_dialog.css";
import { cls_align_items_stretch } from "framework/structural_components/hbox_vbox.css";
var LoginDialog = function () {
    var _a = useLogin(), state = _a[0], actions = _a[1];
    var emailSetter = function (field, value, validator, storeInvalidValue) {
        return actions.loginDialogFieldSetter('email', value);
    };
    var passwordSetter = function (field, value, validator, storeInvalidValue) {
        return actions.loginDialogFieldSetter('password', value);
    };
    return React.createElement(Dialog, { open: state.open },
        React.createElement(DialogContent, null,
            React.createElement(DialogTitle, null, "Přihlášení"),
            React.createElement(VBox, null,
                React.createElement(HBox, { className: cls_gap_form },
                    React.createElement(VBox, { className: [cls_input_box, cls_align_items_stretch] },
                        React.createElement(TextField, { label: "E-mail", name: "email", state: state, setter: emailSetter }))),
                React.createElement(HBox, { className: cls_gap_box_0 }),
                React.createElement(HBox, { className: cls_gap_form },
                    React.createElement(VBox, { className: [cls_input_box, cls_align_items_stretch] },
                        React.createElement(PasswordField, { label: "Heslo", name: "password", state: state, setter: passwordSetter }))),
                React.createElement(HBox, { className: cls_gap_box_0 }),
                state.invalid ? React.createElement(HBox, { className: [cls_gap_form, cls_colorMagenta60] }, "Zadané údaje nejsou správné") : React.createElement(React.Fragment, null),
                React.createElement(HBox, { className: cls_gap_box_1 }),
                React.createElement(HBox, { className: cls_gap_form },
                    React.createElement(Button, { className: cls_button_width, onClick: actions.loginUser }, "Přihlásit"),
                    React.createElement(Button, { className: cls_button_width, onClick: actions.closeLoginDialog, intent: Intent.NotAction }, "Zavřít"))),
            React.createElement(DialogClose, { asChild: true },
                React.createElement(ButtonCloseIcon, { intent: Intent.NotAction, onClick: actions.closeLoginDialog }))));
};
export var LoginButton = function (props) {
    var state_resp = useResponsivity()[0];
    var T_MOB = state_resp.thresholdMenuOnButton;
    var _a = useLogin(), actions = _a[1];
    var uicontext_state = useUIContext()[0];
    return React.createElement(React.Fragment, null, uicontext_state.initialized && React.createElement(React.Fragment, null, T_MOB && !props.disableMobileVersionStyle ? React.createElement(ButtonLoginIcon, { onClick: actions.openLoginDialog }) : React.createElement(Button, { onClick: actions.openLoginDialog }, "PŘIHLÁSIT SE")));
};
var LogoutButton = function () {
    var state_resp = useResponsivity()[0];
    var T_MOB = state_resp.thresholdMenuOnButton;
    var _a = useLogin(), actions = _a[1];
    var uicontext_state = useUIContext()[0];
    return React.createElement(React.Fragment, null, uicontext_state.initialized && React.createElement(React.Fragment, null, T_MOB ? React.createElement(ButtonLogoutIcon, { onClick: actions.logoutUser }) : React.createElement(Button, { intent: Intent.NotAction, onClick: actions.logoutUser }, "Odhl\u00E1sit")));
};
export var LoginComponent = function () {
    var _a;
    var _b = useUIContext(), uicontext_state = _b[0], uicontext_actions = _b[1];
    React.useEffect(function () {
        uicontext_actions.initializeUIContext();
    }, []);
    React.useEffect(function () {
        if (uicontext_state.data.logged_user) {
            uicontext_actions.loadAdminWebCredentialsUIContext();
        }
    }, [(_a = uicontext_state.data.logged_user) === null || _a === void 0 ? void 0 : _a.email]);
    return React.createElement(React.Fragment, null,
        uicontext_state.data.logged_user ? React.createElement(LogoutButton, null) : React.createElement(LoginButton, null),
        React.createElement(LoginDialog, null));
};
